SupportServiceActionsBaseView = require('./service_action_base')
SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache')

class SupportUpdateShippingServiceActionView extends SupportServiceActionsBaseView
  id: 'update_shipping'

  initialize: ->
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportServiceActionButtonTemplate
    @order = Groupon.Support.currentOrder

  render: ->
    @$el.append toHtml(@template, @toHash(), @I18nScope)

  toHash: ->
    hash =
      service_action_id : "update_shipping",
      service_action : I18n.t("js.modules.support.update_shipping")
    @extendHash(hash)

  actionHandler: (event)->
    dealPermalink = Groupon.Support.currentOrder.deal.id
    orderId = Groupon.Support.currentOrder.id
    url = "/deals/#{ dealPermalink }/confirmation/#{ orderId }"
    window.open(url)

  events :
    "click #update_shipping" : "actionHandler"

module.exports = SupportUpdateShippingServiceActionView
